import React from 'react';
import { getEnviroment } from "../../../lib/utils.es6";
import { getPartnerGuid, getAuthorizationToken } from '../../../lib/access.es6';

const PARTNER_CONFIGS = {
  'omu_posbank': {
    staging: "https://ipp-om-uganda-gle.staging.aspin-inclusivity.com",
    production: "https://ipp-om-uganda-gle.inclusivity-aspin.com",
  },
  'om_lions': {
    staging: "https://ipp-om-uganda-gle.staging.aspin-inclusivity.com",
    production: "https://ipp-om-uganda-gle.inclusivity-aspin.com",
  },
  'om_rotary': {
    staging: "https://ipp-om-uganda-gle.staging.aspin-inclusivity.com",
    production: "https://ipp-om-uganda-gle.inclusivity-aspin.com",
  },
  'om_namirembe': {
    staging: "https://ipp-om-uganda-gle.staging.aspin-inclusivity.com",
    production: "https://ipp-om-uganda-gle.inclusivity-aspin.com",
  },
  'centenary_bank': {
    staging: "https://ipp-om-uganda-gle.staging.aspin-inclusivity.com",
    production: "https://ipp-om-uganda-gle.inclusivity-aspin.com",
  },
  'dfcu_ug': {
    staging: "https://ipp-om-uganda-gle.staging.aspin-inclusivity.com",
    production: "https://ipp-om-uganda-gle.inclusivity-aspin.com",
  },
};

class PolicyAmend extends React.Component {
  render() {
    const partnerGuid = getPartnerGuid();
    const source = "aspin";
    const environment = getEnviroment();

    const config = PARTNER_CONFIGS[partnerGuid];
    if (!config) {
      return (
        <section style={{ margin: "30px" }}>
          <p style={{ color: "red" }}>Invalid partner configuration.</p>
        </section>
      );
    }

    const baseUrl = environment === "prod" ? config.production : config.staging;
    const bearerToken = getAuthorizationToken();
    const host_base_url = window.location.origin;
    // Support both route param (/amend-policy/:policy_number) and query param (?policy_number=...)
    // Query param is used when policy number contains special chars like slashes
    const policyNumber =
      (this.props.params && this.props.params.policy_number) ||
      (this.props.location && this.props.location.query && this.props.location.query.policy_number);

    const iframeSrc = `${baseUrl}/?partner=${encodeURIComponent(partnerGuid)}&source=${encodeURIComponent(source)}&mode=amend&bearer_token=${encodeURIComponent(bearerToken)}&host_base_url=${encodeURIComponent(host_base_url)}&environment=${encodeURIComponent(environment)}${policyNumber ? '&policy_number=' + encodeURIComponent(policyNumber) : ''}`;

    console.log('PolicyAmend iframeSrc:', iframeSrc);

    return (
      <>
        <section
          style={{
            background: "#FFFFFF",
            borderRadius: "8px",
            height: "auto",
            marginTop: "30px",
            marginBottom: "30px",
            width: "100%",
          }}
        >
          <iframe
            src={iframeSrc}
            width="100%"
            height="100%"
            style={{
              width: "100%",
              height: "calc(100vh - 100px)",
              border: "none",
            }}
            title="Amend Policy"
          ></iframe>
        </section>
      </>
    );
  }
}

export default PolicyAmend;
